/**
 * Shared env-validation helpers.
 * Each app/function has its own `lib/env.ts` that imports these primitives
 * and validates its specific env contract at boot.
 */

import { z } from 'zod';
import { SchemaValidationFailedError } from './errors.js';

export const FirebaseClientConfigSchema = z.object({
  apiKey: z.string().min(1),
  authDomain: z.string().min(1),
  projectId: z.string().min(1),
  storageBucket: z.string().min(1),
  messagingSenderId: z.string().min(1),
  appId: z.string().min(1),
  measurementId: z.string().optional(),
});
export type FirebaseClientConfig = z.infer<typeof FirebaseClientConfigSchema>;

/** Parse a value with a Zod schema, throwing a typed error if invalid. */
export function parseEnv<T extends z.ZodTypeAny>(
  schema: T,
  value: unknown,
  name: string,
): z.infer<T> {
  const result = schema.safeParse(value);
  if (!result.success) {
    throw new SchemaValidationFailedError(`env:${name}`, result.error.flatten());
  }
  return result.data;
}
